exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".FileUpload__wrapper___2Rn_5 {\n  margin-bottom: 25px;\n}\n\n.FileUpload__imagesWrapper___2s_Jv {\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -ms-flex-align: start;\n      align-items: flex-start;\n}\n\n.FileUpload__image___3h8ec {\n  width: 200px;\n  border: 1px solid #d4d4d4;\n  position: relative;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n\n.FileUpload__image___3h8ec span {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.5);\n  color: white;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  cursor: pointer;\n  opacity: 0;\n  -webkit-transition: opacity 0.1s linear;\n  -o-transition: opacity 0.1s linear;\n  transition: opacity 0.1s linear;\n}\n\n.FileUpload__image___3h8ec:hover span {\n  opacity: 1;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "FileUpload__wrapper___2Rn_5",
	"imagesWrapper": "FileUpload__imagesWrapper___2s_Jv",
	"image": "FileUpload__image___3h8ec"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/FileUpload/FileUpload.css
// module id = 555
// module chunks = 0